<template>
  <div id="event"></div>
</template>
<script>
export default {
  name: "event",
  created() {
    var self = this;
    window.addEventListener("keydown", function(e) {
      if (e.target && e.target.contentEditable == "true" && e.key != "Escape") {
        return;
      }
      if (e.key == "F4") {
        if (e.shiftKey) {
          self.$emit("doSaveContinue");
        } else {
          self.$emit("doSave");
        }
        e.preventDefault();
      } else if (e.key == "Escape") {
        self.$emit("doCancel");
        e.preventDefault();
      } else if (e.key == "Delete") {
        self.$emit("doDelete");
        e.preventDefault();
      } else if (!e.target.type) {
        switch (e.key) {
          case "a":
            self.$emit("doAdd");
            e.preventDefault();
            break;
          case "e":
            self.$emit("doEdit");
            e.preventDefault();
            break;
        }
      }
    });
  },
  components: {},
  methods: {}
};
</script>
